import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageFallback } from "@/components/store/Skeletons";

export function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <PageFallback />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user === null) return <PageFallback full />;
  if (!user) return <Navigate to="/admin-login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
